export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    HEAD = 'HEAD',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE'
}
